export const authRoles = {
    SuperAdmin: 1,
    Admin: 2,
    Provider: 3,
    Parents: 4,
    Guest:5
}